export default __webpack_public_path__ + "static/media/newbook.cce7e46b.svg";